export default __webpack_public_path__ + "static/media/santa-maria-7.b9e1520b.jpg";